import React, { useState, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { getApiCall } from "../../../service/httpCall"; // Adjust the path if necessary
import Loader from "../../../components/partials/components/loader";
import ToastNotification from "../../../components/Toast";
import '@fortawesome/fontawesome-free/css/all.min.css';
import "../../../assets/custom/css/custom.css";
import { API_INCOMING_SUMMARY_LIST, DOWNLOAD_REPORT } from '../../../service/url';
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Dropdown } from "primereact/dropdown";
import { postApiCall } from '../../../service/httpCall';
import LottieAnimation from '../../../components/lottie/lottie';
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import exportData from "../../../utilities/export";
import { Storage } from "../../../utilities/setting";
import { toast } from "react-toastify";
import {
  loadPortalReportData,
  PORTAL_REPORT_RESOURCES,
} from "../../../utilities/portalReportRefresh";
import { exportToCSV, hasPermission } from '../../../utilities/helpers';
import { getUser } from "../../../utilities/setting";


const dateToInputStr = (d) => {
  if (!d) return "";
  const dt = d instanceof Date ? d : new Date(d);
  if (Number.isNaN(dt.getTime())) return "";
  const y = dt.getFullYear();
  const m = String(dt.getMonth() + 1).padStart(2, "0");
  const day = String(dt.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};

const inputStrToLocalDate = (str) => {
  if (!str) return null;
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(str);
  if (!m) {
    const d = new Date(str);
    return Number.isNaN(d.getTime()) ? null : d;
  }
  return new Date(parseInt(m[1], 10), parseInt(m[2], 10) - 1, parseInt(m[3], 10));
};

const DownloadReport = () => {
  const [incomingSummary, setDownloadReport] = useState([]);
  const [loading, setLoading] = useState(false);
  const [toastProps, setToastProps] = useState(null);
  const [showToast, setShowToast] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [filters, setFilters] = useState({
      name: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
      },
    });
  
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [selectedDid, setSelectedDid] = useState(null);
//   const [didOptions, setDidOptions] = useState([]); 
  const [showToastModal, setShowToastModal] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [loggedInUserId, setLoggedInUserId] = useState(null);
  const [loggedInUserRole, setLoggedInUserRole] = useState(null);



  const showToasts = (message) => {
    setToastMessage(message);
    setShowToastModal(true);

    // Hide modal automatically after 3 seconds
    setTimeout(() => {
        setShowToastModal(false);
    }, 3000);
};
  
    const handleFilter = () => {
      if ((!startDate || !endDate) && !selectedDid) {
        setFilteredData(incomingSummary);
        return;
      }
  
      const startOfDay = new Date(startDate);
      startOfDay.setHours(0, 0, 0, 0);
    
      const endOfDay = new Date(endDate);
      endOfDay.setHours(23, 59, 59, 999);

      let filtered = filteredData

      if (startDate || endDate) {
        filtered = incomingSummary.filter((data) => {
            const incommingData = new Date(data.requested_date);
            return incommingData >= startOfDay && incommingData <= endOfDay;
        });
      }
  
      setFilteredData(filtered);
    };

    const applyDownloadReportList = (resp) => {
      if (!resp) {
        return;
      }

      const updatedList = resp.map((val, idx) => {
        const data = val.dataValues || val;
        return {
          ...data,
          key: idx + 1,
        };
      });

      setDownloadReport(updatedList);
      setFilteredData(updatedList);
    };

    const fetchDownloadReport = async (force = false) => {
      if (!loggedInUserId || !loggedInUserRole) {
        return;
      }

      try {
        const result = await loadPortalReportData({
          resource: PORTAL_REPORT_RESOURCES.DOWNLOAD_REPORT_LIST,
          userId: loggedInUserId,
          role: loggedInUserRole,
          params: {},
          force,
          onBlocked: (remainingMs) => {
            toast.info(
              `Download report list can be refreshed after ${Math.ceil(remainingMs / 1000)} seconds.`
            );
          },
          fetchFn: () => getApiCall(DOWNLOAD_REPORT),
        });
        applyDownloadReportList(result.data);
      } catch (error) {
        console.log(error);
      }
    };

    useEffect(() => {
      const fetchUserData = async () => {
        const rawUser = Storage.getItem("user");
        if (!rawUser) {
          return;
        }

        try {
          const user = JSON.parse(rawUser);
          setLoggedInUserId(user?.id);
          setLoggedInUserRole(user?.role);
        } catch (error) {
          console.error("Invalid JSON in Storage user:", error);
        }
      };

      fetchUserData();
    }, []);

    useEffect(() => {
      if (loggedInUserId && loggedInUserRole) {
        fetchDownloadReport(false);
      }
    }, [loggedInUserId, loggedInUserRole]);

     const handleReset = () => {
        setStartDate(null);
        setEndDate(null);
        setFilteredData(incomingSummary);
      };   

      const [moduleOperationsForReadPermissionCheck, setModuleOperationsForReadPermissionCheck] = useState({});
      
        useEffect(() => {
          const user = getUser();
            if (user) {
              if (user?.acl_settings) {    
                setModuleOperationsForReadPermissionCheck(JSON.parse(user.acl_settings.module_operations));
              }
            }
        }, []);

    const downloadFile = (rowData) => {
        if (!rowData || !rowData.download_link) {
            console.error("Download link is missing.");
            return;
        }
    
        const link = document.createElement("a");
        link.href = rowData.download_link;
        link.download = rowData.download_link.split('/').pop();
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const reportStatus = (rowData) => {
      let reportStatus='';
			switch (rowData.status) {
				case "0":
					reportStatus = 'Initiated';
					break;
				case "1":
					reportStatus = 'Processing';
					break;
				case "2":
					reportStatus = 'Ready for Download';
					break;
				default:
					reportStatus = '';
					break;
			}
      
      return reportStatus;
    }
     const handleExport = async () => {
   try {
      // setButtonDisable(true);

      exportToCSV({
         fileName: "download-report-list",
         data: filteredData,
         columns: [
            {
               header: "Did",
               accessor: "did"
            },
            {
               header: "User Id",
               accessor: "user_id"
            },
            {
               header: "Schedule Date",
               accessor: (row) =>
                  row.schedule_date
                     ? new Date(row.schedule_date).toLocaleString(
                        "en-IN",
                        {
                           day: "2-digit",
                           month: "short",
                           year: "numeric",
                           hour: "2-digit",
                           minute: "2-digit",
                           second: "2-digit",
                        }
                     )
                     : "-"
            },
            {
               header: "Requested Date",
               accessor: (row) =>
                  new Date(row.requested_date).toLocaleString(
                     "en-IN",
                     {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        second: "2-digit",
                     }
                  )
            },
            {
               header: "Report Status",
               accessor: (row) =>
                  reportStatus(row)
            },
            {
               header: "Report Type",
               accessor: "report_type"
            }
         ]
      });

   } finally {
      // setButtonDisable(false);
   }
};

    const actionBodyTemplate = (rowData) => {
        
      if(rowData.status == 2){
        return (
            <div className="d-flex justify-space-between gap-2">
                <button
                    className="btn-icons m-1"
                    onClick={() => downloadFile(rowData)}
                    disabled={!rowData.download_link}
                    style={{
                        marginLeft: '8px',
                        border: 'none',
                        background: 'none',
                        padding: '0',
                        cursor: rowData.download_link ? 'pointer' : 'not-allowed',
                        opacity: rowData.download_link ? 1 : 0.5,
                    }}
                >
                    <i className="fa fa-download" aria-hidden="true" style={{ color: 'blue', fontSize: '24px' }}></i>
                </button>
            </div>
        );
      }else{
          return <></>
      }
    };

    const canRead = hasPermission(
         moduleOperationsForReadPermissionCheck,
         "Download Report",
         "read",
       );
     
       if (Object.keys(moduleOperationsForReadPermissionCheck).length > 0 && !canRead) {
         return (
           <div
             className="text-center p-4"
             style={{
               marginTop: "50px",
               marginBottom: "50px",
               fontSize: "16px",
             }}
           >
             No read permission found in assigned ACL
           </div>
         );
       }

  if (loading) {
    return <Loader />;
  }

  return (
    <>
    <div>
      <div className="card" style={{ marginTop: "20px" }}>
        <div className="card-header d-flex justify-content-between align-items-center">
          <h4 className="card-title">Download Reports</h4>
          {
                                        filteredData.length > 0 &&
                                        <Button
                                        label="Export Data"
                                        onClick={handleExport}
                                        className="p-button-active p-button-sm"
                                        style={{ marginBottom: "10px", marginLeft: "10px" }}
                                      >
                                        
                                      </Button>
                                      }
        </div>
        <div className="card-body">
                <div className="d-flex align-items-center mb-3" style={{ marginLeft: "10px" }}>
                  <Form.Control
                    type="date"
                    value={dateToInputStr(startDate)}
                    placeholder="Start Date"
                    onChange={(e) => setStartDate(inputStrToLocalDate(e.target.value))}
                  />
                  <span className="mx-2">to</span>
                  <Form.Control
                    type="date"
                    value={dateToInputStr(endDate)}
                    placeholder="End Date"
                    onChange={(e) => setEndDate(inputStrToLocalDate(e.target.value))}
                  />
                  <Button
                    label="Filter"
                    onClick={handleFilter}
                    className="p-button-sm p-button-primary mx-2"
                  />
                  <Button
                    label="Reset"
                    onClick={handleReset}
                    className="p-button-sm p-button-secondary"
                  />
                </div>
          <div className="scroll-container">
            <DataTable
              value={filteredData}
              paginator
              rows={10}
              tableStyle={{ minWidth: "50rem" }}
              filters={filters}
            >
              <Column field="did" header="Did" filterPlaceholder="Search by name" />
              <Column field="user_id" header="User Id" filterPlaceholder="Search by URL" />
              <Column field="schedule_date" header="Schedule Date" filterPlaceholder="Search by duration" body={(rowData) =>
              rowData.schedule_date
              ? new Date(rowData.schedule_date).toLocaleString("en-IN", {
                day: "2-digit",
                month: "short",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
              })
              : "-"
              }/>
              <Column field="requested_date" header="Requested date" filterPlaceholder="Search by duration" body={(rowData) =>
                                    new Date(rowData.requested_date).toLocaleString("en-IN", {
                                       day: "2-digit",
                                       month: "short",
                                       year: "numeric",
                                       hour: "2-digit",
                                       minute: "2-digit",
                                       second: "2-digit",
                                    })
                                 }/>
              <Column field={reportStatus} header="Report Status" filterPlaceholder="Search by category" />
              <Column field="report_type" header="Report type" filterPlaceholder="Search by name" />
              {/* <Column field="download_link" header="Download link" filterPlaceholder="Search by URL" /> */}
              <Column
                header="Download Link"
                body={actionBodyTemplate}
                style={{ textAlign: "center", width: "12rem" }}
              />
            </DataTable>
          </div>
        </div>
      </div>
      <ToastNotification
        show_toast={showToast}
        set_show_toast={setShowToast}
        {...toastProps}
      />
      {/* LOTTIE MODEL FOR TOAST */}
             <Modal show={showToastModal} centered onHide={() => setShowToastModal(false)} size="sm">
                      <Modal.Body className="text-center">
                          <h5>{toastMessage}</h5>
                          <LottieAnimation animationData={"https://assets6.lottiefiles.com/packages/lf20_touohxv0.json"} />
                      </Modal.Body>
                  </Modal>
    </div>
          </>    
  );
};

export default DownloadReport;
